export const tokens = {
  common: {
    languageChanged: 'common.languageChanged',
  },
  nav: {
    account: 'nav.account',
    analytics: 'nav.analytics',
    auth: 'nav.auth',
    concepts: 'nav.concepts',
    users: 'nav.users',
    dashboard: 'nav.dashboard',
    details: 'nav.details',
    error: 'nav.error',
    forgotPassword: 'nav.forgotPassword',
    list: 'nav.list',
    login: 'nav.login',
    profile: 'nav.profile',
    register: 'nav.register',
    resetPassword: 'nav.resetPassword',
    verifyCode: 'nav.verifyCode',
    seace: 'nav.seace',
    mivivienda: 'nav.mivivienda',
    operaciones: 'nav.operaciones',
    tablero: 'nav.tablero',
    inversionistas: 'nav.inversionistas',
    pymes: 'nav.pymes',
    comunicaciones: 'nav.comunicaciones',
    estructuracion: 'nav.estructuracion',
    llamadoCapital: 'nav.llamadoCapital',
    seguimiento: 'nav.seguimiento',
    fiduciaria: 'nav.fiduciaria',
    tiposInversion: 'nav.tiposInversion',
    configuracion: 'nav.configuracion',
    honorarios: 'nav.honorarios',
    cierre: 'nav.cierre',
    archivos: 'nav.archivos',
    misInversiones: 'nav.misInversiones',
    invDashboard: 'nav.invDashboard',
    panel: 'nav.panel',
    oportunidades: 'nav.oportunidades',
    misInversionesDetail: 'nav.misInversionesDetail',
    inversionesActivas: 'nav.inversionesActivas',
    estadoCuenta: 'nav.estadoCuenta',
    historial: 'nav.historial',
    miPyme: 'nav.miPyme',
    pymeDashboard: 'nav.pymeDashboard',
    solicitar: 'nav.solicitar',
    cotizador: 'nav.cotizador',
    cronograma: 'nav.cronograma',
    facturacion: 'nav.facturacion',
    contrato: 'nav.contrato',
    alertas: 'nav.alertas',
  },
};
